import { createApi } from '@reduxjs/toolkit/query/react';
import { btBaseQuery } from 'src/Common/common';

// Define a service using a base URL and expected endpoints
export const acsettingApi = createApi({
  reducerPath: 'acsettingApi',
  baseQuery: btBaseQuery,
  tagTypes: ['ACASetting'],

  endpoints: (builder) => ({
    getACSettings: builder.query<ac_asetting[], void>({
      query: () => `acsetting/`,
      providesTags: ['ACASetting']
    }),
    getACSettingById: builder.query<ac_asetting, string>({
      query: (id) => `acsetting/byid/${id}`,
      providesTags: ['ACASetting']
    }),
    insertACSetting: builder.mutation({
      query: (acsetting) => ({
        url: `acsetting/`,
        method: 'POST',
        body: acsetting
      }),
      invalidatesTags: ['ACASetting']
    }),
    updateACSetting: builder.mutation({
      query: (acsetting) => ({
        url: `acsetting/`,
        method: 'PUT',
        body: acsetting
      }),
      invalidatesTags: ['ACASetting']
    }),
    deleteACSetting: builder.mutation({
      query: (acsetting) => ({
        url: `acsetting/${acsetting.se_id}`,
        method: 'DELETE',
        body: acsetting
      }),
      invalidatesTags: ['ACASetting']
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetACSettingsQuery,
  useGetACSettingByIdQuery,
  useInsertACSettingMutation,
  useUpdateACSettingMutation,
  useDeleteACSettingMutation
} = acsettingApi;
